export const DEFAULT_ARTWORKS = [
  {
    number: 1,
    title: "Hanuman — The Light of Devotion",
    medium: "Oil on Canvas",
    size: '32" x 24"',
    year: "2026",
    price: "₹95,000 (India)",
    story:
      "A hand-painted artwork inspired by Lord Hanuman's unwavering devotion, strength, and spiritual energy. The glowing diya represents faith and devotion, while the warm tones create a feeling of divine light and inner peace. Entirely created by hand with careful detailing and artistic brushwork.",
    image: "/artwork/art-hanuman.jpg",
  },
  {
    number: 2,
    title: "Magnificent Elephant",
    medium: "Acrylic on Canvas",
    size: '20" x 24"',
    year: "2026",
    price: "₹55,000 (India)",
    story:
      "The upward sweep of the trunk is a classical motif signifying strength, positive energy, and resilience. The calm, focused gaze of the eye, framed by deeply etched skin folds, evokes wisdom and quiet endurance.",
    image: "/artwork/art-elephant.jpg",
  },
  {
    number: 3,
    title: "Lotus",
    medium: "Acrylic on Canvas",
    size: '24" x 30"',
    year: "2026",
    price: "₹65,000 (India)",
    story:
      "A vibrant acrylic on canvas capturing pink lotus blooms in three life stages against a deep midnight-blue ground — a fully opened lotus commanding the upper right, a floating crimson-pink blossom at the lower left, and a rising bud flanked by broad green lily pads. Rippling cerulean water anchors the foreground, creating a striking contrast with the warm floral tones.",
    image: "/artwork/art-lotus.jpg",
  },
  {
    number: 4,
    title: "Fruits & Wine Still Life",
    medium: "Oil on Canvas",
    size: '20" x 24"',
    year: "2026",
    price: "₹55,000 (India)",
    story:
      "A classic still life composition capturing the richness of fruits, the elegance of wine, and the timeless beauty of oil painting. Hand-painted with attention to light, shadow, texture, and detail.",
    image: "/artwork/art-stilllife.jpg",
  },
  {
    number: 5,
    title: "Evening Melody",
    medium: "Oil on Canvas",
    size: '30" x 38"',
    year: "2026",
    price: "₹95,000 (India)",
    story:
      "A figurative oil painting of a woman in a flowing gold satin dress, seated at a piano with a glass of red wine, lit by candlelight and red roses. Hand-painted with rich light, shadow and texture.",
    image: "/artwork/cover-art.jpg",
  },
  {
    number: 6,
    title: "Red Parrot",
    medium: "Acrylic on Canvas",
    size: '24" x 36"',
    year: "2026",
    price: "₹85,000 (India)",
    story:
      "A striking acrylic portrait of a scarlet macaw in close profile — fiery reds and warm oranges blazing against a deep black ground. The steady golden eye, crackled pale beak and hand-layered feathers give the bird presence, pride and personality. Entirely hand-painted with fine brushwork and rich detail.",
    image: "/artwork/art-parrot.jpg",
  },
];

export const DEFAULT_CONTENT = {
  tagline: "Turning emotions and memories into art.",
  whatsapp: "",
  email: "artwith.saivisaloni@gmail.com",
  instagram: "artwith.saivi",
  whatsapp2: "",
  email2: "",
  instagram2: "",
  quote:
    "For me, painting is more than just putting colours on a canvas — it is a way of expressing emotions, capturing memories, and creating something that can be treasured for years.",
  about_paragraphs: [
    "I'm Saivi — a visual artist, painter, and graphic designer passionate about creating meaningful artwork. My artistic journey is rooted in original handmade canvas paintings, where I bring ideas, emotions, memories, and everyday beauty to life through colour and brushwork.",
    "I mainly work with oil and acrylic colours, creating original paintings inspired by portraits, people, nature, landscapes, still life, and personal memories. I also create custom paintings from photographs, turning special moments into unique pieces of art.",
    "Each artwork is originally painted by hand on canvas, with attention to detail, patience, and my own artistic style. I enjoy experimenting with colours, textures, light, and composition to give every painting its own character.",
  ],
};
